module.exports = __webpack_public_path__ + "img/8.fa07236e.jpg";